import model from 'modules/ccm/ccmModel';

const { fields } = model;

export default [
  fields.id,
  fields.type,
  fields.content,
  fields.subject,
  fields.trigger,
  fields.company,
  fields.enable,
  fields.createdAt,
  fields.updatedAt,
];
